;(() => {
  if (
    WC?.idMenu !== 37 ||
    ![
      '/it/altopiano_di_asiago/asiago/comune/',
      '/it/altopiano_di_asiago/enego/comune/',
      '/it/altopiano_di_asiago/foza/',
      '/it/altopiano_di_asiago/gallio/',
      '/it/altopiano_di_asiago/lusiana_conco/',
      '/it/altopiano_di_asiago/roana/comune/',
      '/it/altopiano_di_asiago/rotzo/',
      // '/en/asiago_plateau/asiago/municipality/',
      // '/en/asiago_plateau/enego/municipality/',
      // '/en/asiago_plateau/foza/',
      // '/en/asiago_plateau/gallio/',
      // '/en/asiago_plateau/lusiana_conco/',
      // '/en/asiago_plateau/roana/municipality/',
      // '/en/asiago_plateau/rotzo/',
      // '/de/hochebene_von_asiago/asiago/gemeinde/',
      // '/de/hochebene_von_asiago/enego/gemeinde/',
      // '/de/hochebene_von_asiago/foza/',
      // '/de/hochebene_von_asiago/gallio/',
      // '/de/hochebene_von_asiago/lusiana_conco/',
      // '/de/hochebene_von_asiago/roana/gemeinde/',
      // '/de/hochebene_von_asiago/rotzo/',
    ].includes(window.location.pathname)
  ) {
    return
  }

  const riquadro =
    document.querySelector('.body-page > .gallery-cnt') ||
    document.querySelector('.body-page .riquadro > .gallery-cnt')
  let agenzieImmobiliari = Array.from(riquadro.querySelectorAll('h2'))?.find(
    node => node.textContent === 'Agenzie Immobiliari'
  )

  // realestate agencies
  if (agenzieImmobiliari) {
    const realestateAgenciesDiv = generateSection()
    const realestateAgencies = generateAgencies(scrapRealEstateAgenciesData(agenzieImmobiliari))
    const realestateAgenciesTitle = generateTitleNode('Agenzie Immobiliari')

    riquadro.parentNode.insertBefore(realestateAgenciesDiv, riquadro.nextSibling)
    realestateAgenciesDiv.appendChild(realestateAgenciesTitle)
    realestateAgenciesDiv.appendChild(realestateAgencies)
  }

  // realestate links
  const realestateLinksDiv = generateSection()
  const realestateLinks = generateMunicipalityRealEstateLinks()
  const realestateLinksTitle = generateTitleNode('Case e appartamenti in affitto e vendita')

  riquadro.parentNode.insertBefore(realestateLinksDiv, riquadro.nextSibling)
  realestateLinksDiv.appendChild(realestateLinksTitle)
  realestateLinksDiv.appendChild(realestateLinks)
})()

function generateAgencies(data) {
  const container = document.createElement('ul')
  container.classList.add('realestate-agencies__list')

  data.forEach(agency => {
    const node = document.createElement('li')
    node.classList.add('realestate-agencies__item')

    node.innerHTML = `
			<a href="${agency.link}" target="_blank" class="realestate-agencies__agency realestate-agencies-agency">
				<div class="realestate-agencies-agency__images">
					<picture class="realestate-agencies-agency__picture">
						<img src="${agency.imageSrc}" alt="${agency.imageAlt}" class="realestate-agencies-agency__image">
					</picture>
				</div>
				<div class="realestate-agencies-agency__copy">
					<header class="realestate-agencies-agency__header">
						<h3 class="realestate-agencies-agency__title">${agency.title}</h3>
					</header>
				</div>
			</a>
		`

    container.appendChild(node)
  })

  return container
}

function scrapRealEstateAgenciesData(galleryTitle) {
  const gallery = galleryTitle.parentNode

  const data = []
  const links = Array.from(gallery.querySelectorAll('a.gallery-foto-cnt')).filter(a => {
    return a.href?.startsWith('https://www.asiago.it/it/agenzie_immobiliari/')
  })

  links.forEach(element => {
    data.push({
      link: element.href,
      title: element.querySelector('h1').textContent.trim(),
      imageSrc: element.querySelector('img').src,
      imageAlt: element.querySelector('img').alt,
    })

    element.remove()
  })

  galleryTitle.remove()

  return data
}

function generateSection() {
  const node = document.createElement('section')
  node.classList.add('dk-realestate-section')

  return node
}

function generateTitleNode(text) {
  const node = document.createElement('h2')
  node.classList.add('dk-realestate-section__title')
  node.textContent = text

  return node
}

function generateMunicipalityRealEstateLinks() {
  let comune =
    document.querySelector('.body-page .navsci .boxTitoloHot > h1') ||
    document.querySelector('.body-page #content > h1')
  comune = comune.textContent.split(' - ')[0].replace('Comune di ', '').trim()
  const comuneSlug = comune.toLowerCase().split(' ').join('_')
  const prep = comuneSlug.substring(0, 1) === 'a' ? 'ad' : 'a'

  const node = document.createElement('section')
  node.classList.add('municipality-realestate-links')

  node.innerHTML = `
		<div class="municipality-realestate-links__container">
			<ul class="municipality-realestate-links__list">
				<li class="municipality-realestate-links__item">
					<a target="_blank" href="https://case.asiago.it/it/cerca/?contratto=affitto_turistico&comune=${comuneSlug}#main" class="municipality-realestate-links__link">
						<div class="municipality-realestate-links__picture">
							<img src="/images/realestate/municipality-realestate-links/affitto_turistico.jpg" alt="Case e appartamenti in affitto turistico a ${comune}" class="municipality-realestate-links__image">
						</div>
						<div class="municipality-realestate-links__copy">
							<div class="municipality-realestate-links__box municipality-realestate-links-box">
								<header class="municipality-realestate-links-box__header">
									<div class="municipality-realestate-links-box__left">
										<span class="municipality-realestate-links-box__icon">deck</span>
										<span class="municipality-realestate-links-box__title">Aff. Turistico</span>
									</div>
									<div class="municipality-realestate-links-box__right">
										<span class="municipality-realestate-links-box__icon">keyboard_arrow_right</span>
									</div>
								</header>
								<section class="municipality-realestate-links-box__body">
									<p class="municipality-realestate-links-box__text">Clicca per scoprire tutti gli immobili in affitto turistico ${prep} ${comune}</p>
								</section>
							</div>
						</div>
					</a>
				</li>
				<li class="municipality-realestate-links__item">
					<a target="_blank" href="https://case.asiago.it/it/cerca/?contratto=affitto&comune=${comuneSlug}#main" class="municipality-realestate-links__link">
						<div class="municipality-realestate-links__picture">
							<img src="/images/realestate/municipality-realestate-links/affitto.jpg" alt="Case e appartamenti in affitto a ${comune}" class="municipality-realestate-links__image">
						</div>
						<div class="municipality-realestate-links__copy">
							<div class="municipality-realestate-links__box municipality-realestate-links-box">
								<header class="municipality-realestate-links-box__header">
									<div class="municipality-realestate-links-box__left">
										<span class="municipality-realestate-links-box__icon">date_range</span>
										<span class="municipality-realestate-links-box__title">Affitto</span>
									</div>
									<div class="municipality-realestate-links-box__right">
										<span class="municipality-realestate-links-box__icon">keyboard_arrow_right</span>
									</div>
								</header>
								<section class="municipality-realestate-links-box__body">
									<p class="municipality-realestate-links-box__text">Clicca per scoprire tutti gli immobili in affitto ${prep} ${comune}</p>
								</section>
							</div>
						</div>
					</a>
				</li>
				<li class="municipality-realestate-links__item">
					<a target="_blank" href="https://case.asiago.it/it/cerca/?contratto=vendita&comune=${comuneSlug}#main" class="municipality-realestate-links__link">
						<div class="municipality-realestate-links__picture">
							<img src="/images/realestate/municipality-realestate-links/acquisto_immobile.jpg" alt="Case e appartamenti in vendita a ${comune}" class="municipality-realestate-links__image">
						</div>
						<div class="municipality-realestate-links__copy">
							<div class="municipality-realestate-links__box municipality-realestate-links-box">
								<header class="municipality-realestate-links-box__header">
									<div class="municipality-realestate-links-box__left">
										<span class="municipality-realestate-links-box__icon">account_balance</span>
										<span class="municipality-realestate-links-box__title">Vendita imm.</span>
									</div>
									<div class="municipality-realestate-links-box__right">
										<span class="municipality-realestate-links-box__icon">keyboard_arrow_right</span>
									</div>
								</header>
								<section class="municipality-realestate-links-box__body">
									<p class="municipality-realestate-links-box__text">Clicca per scoprire tutti gli immobili in vendita ${prep} ${comune}</p>
								</section>
							</div>
						</div>
					</a>
				</li>
			</ul>
		</div>
	`

  return node
}
